import { SUPPORTTYPE } from '../constants/bakery/nft'

export function userTokenDecimals(tokenName?: string) {
  let decimals = 18
  switch (tokenName) {
    case SUPPORTTYPE.RACA:
      decimals = 9
      break
    case SUPPORTTYPE.DOGE:
      decimals = 8
      break
  }
  return decimals
}
